export default __webpack_public_path__ + "5905092dd1d11071a2eeaeaaadcbdfd3.png";